import { render, staticRenderFns } from "./addtrends.vue?vue&type=template&id=48273516&scoped=true"
import script from "./addtrends.vue?vue&type=script&lang=js"
export * from "./addtrends.vue?vue&type=script&lang=js"
import style0 from "./addtrends.vue?vue&type=style&index=0&id=48273516&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48273516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48273516')) {
      api.createRecord('48273516', component.options)
    } else {
      api.reload('48273516', component.options)
    }
    module.hot.accept("./addtrends.vue?vue&type=template&id=48273516&scoped=true", function () {
      api.rerender('48273516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pricetrend/addtrends.vue"
export default component.exports